import { Instagram, Mail, MessageCircle } from "lucide-react";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-kora-forest-deep border-t border-kora-gold/20 pt-16 pb-6"
    >
      <div className="max-w-[1480px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-12 mb-10">
          <div className="md:col-span-6">
            <a
              href="#hero"
              className="flex items-baseline gap-1 text-kora-cream"
            >
              <span className="font-display text-3xl tracking-tight">
                KORA
              </span>
              <span className="font-display italic text-3xl text-kora-gold-light">
                Club
              </span>
            </a>
            <p className="font-display italic text-2xl md:text-3xl text-kora-gold-light mt-4 max-w-md">
              Movimento que te define.
            </p>
            <p className="text-sm text-kora-cream/60 mt-4 max-w-md leading-relaxed">
              Activewear premium para a mulher que nunca parou de se mover.
              Feita no Brasil.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="font-mono-label text-kora-gold-light mb-4">Navegar</p>
            <ul className="space-y-2.5 text-kora-cream/80">
              <li>
                <a
                  href="#colecao"
                  className="link-underline"
                  data-testid="footer-link-colecao"
                >
                  Coleção
                </a>
              </li>
              <li>
                <a
                  href="#manifesto"
                  className="link-underline"
                  data-testid="footer-link-manifesto"
                >
                  A Kora Club
                </a>
              </li>
              <li>
                <a
                  href="#vip"
                  className="link-underline"
                  data-testid="footer-link-vip"
                >
                  Lista VIP
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="font-mono-label text-kora-gold-light mb-4">Conecte</p>
            <ul className="space-y-2.5 text-kora-cream/80">
              <li>
                <a
                  href="https://www.instagram.com/UseKoraClub"
                  target="_blank"
                  rel="noreferrer noopener"
                  data-testid="footer-instagram"
                  className="inline-flex items-center gap-2 link-underline"
                >
                  <Instagram size={14} /> Instagram
                </a>
              </li>
              <li>
                <a
                  href="https://wa.me/5565999426211"
                  target="_blank"
                  rel="noreferrer noopener"
                  data-testid="footer-whatsapp"
                  className="inline-flex items-center gap-2 link-underline"
                >
                  <MessageCircle size={14} /> WhatsApp
                </a>
              </li>
              <li>
                <a
                  href="mailto:ola@koraclub.com.br"
                  data-testid="footer-email"
                  className="inline-flex items-center gap-2 link-underline"
                >
                  <Mail size={14} /> E-mail
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="kora-hr" />

        <div className="pt-5 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <p className="font-mono-label text-kora-cream/55">
            © 2026 Kora Club. Todos os direitos reservados.
          </p>
          <p className="font-mono-label text-kora-cream/40">
            Feito no Brasil ✦ Para mulheres em movimento
          </p>
        </div>
      </div>
    </footer>
  );
};
